import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Card, Badge } from "../../components/ui/Card";
import Button from "../../components/ui/Button";
import { formatPrice } from "../../lib/utils";

const STATUS_VARIANT = { requested: "default", approved: "primary", processed: "accent", rejected: "default" };

export default function Refunds() {
  const [refunds, setRefunds] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () =>
    api
      .get("/admin/refunds")
      .then(({ data }) => setRefunds(data.data || []))
      .catch(() => setRefunds([]))
      .finally(() => setLoading(false));

  useEffect(() => {
    load();
  }, []);

  const resolve = async (id, decision) => {
    await api.post(`/admin/refunds/${id}/resolve`, { decision });
    load();
  };

  if (loading) return <p className="text-muted-foreground">Loading…</p>;

  return (
    <div>
      <h1 className="mb-6 font-montserrat text-2xl font-bold text-slate-900">Refund disputes</h1>
      <div className="space-y-3">
        {refunds.map((r) => (
          <Card key={r.id} className="p-4">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="min-w-0">
                <p className="font-semibold text-slate-900">{r.appointment?.business?.name}</p>
                <p className="text-xs text-muted-foreground break-words">
                  Customer: {r.appointment?.customer?.full_name} · {formatPrice(r.amount)}
                </p>
                {r.reason && <p className="mt-1 text-sm text-slate-600 break-words">"{r.reason}"</p>}
              </div>
              <div className="flex flex-wrap items-center gap-2">
                <Badge variant={STATUS_VARIANT[r.status]}>{r.status}</Badge>
                {r.status === "requested" && (
                  <>
                    <Button size="sm" onClick={() => resolve(r.id, "approve")}>Approve</Button>
                    <Button size="sm" variant="outline" onClick={() => resolve(r.id, "reject")}>Reject</Button>
                  </>
                )}
              </div>
            </div>
          </Card>
        ))}
        {refunds.length === 0 && <p className="text-muted-foreground">No refund disputes.</p>}
      </div>
    </div>
  );
}
